<script lang="ts">
    import balanceIcon from 'src/components/#assets/realis-icon.svg'
    import dashboard from 'src/components/cabinet/#assets/dashboard.svg'
    import dashboardOrange from 'src/components/cabinet/#assets/dashboard-orange.svg'
    import marketplace from 'src/components/cabinet/#assets/marketplace.svg'
    import marketplaceOrange from 'src/components/cabinet/#assets/marketplace-orange.svg'
    import {Link} from 'svelte-routing'
    import IconifyIcon from '@iconify/svelte'
    import dashboardIcon from '@iconify/icons-fa-solid/tachometer-alt'
    import userIcon from '@iconify/icons-fa-solid/user-alt'
    import walletIcon from '@iconify/icons-fa-solid/wallet'
    import heroIcon from '@iconify/icons-fa-solid/street-view'
    import membershipsIcon from '@iconify/icons-fa-solid/gem'
    import runIcon from '@iconify/icons-fa-solid/running'
    import cogIcon from '@iconify/icons-fa-solid/cog'
    import questionIcon from '@iconify/icons-fa-solid/question-circle'
    import logoutIcon from '@iconify/icons-fa-solid/sign-out-alt'
    import referralsIcon from '@iconify/icons-fa-solid/user-friends'
    import spinIcon from '@iconify/icons-fa-solid/dharmachakra'
    import stakingIcon from '@iconify/icons-fa-solid/coins'
    import swapIcon from '@iconify/icons-fa-solid/retweet'
    import notificationIcon from '@iconify/icons-fa-solid/bell'
    import marketplaceIcon from '@iconify/icons-fa-solid/store'
    import inventoryIcon from '@iconify/icons-fa-solid/dragon'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import {userProfile} from 'src/services/auth'
    import {api} from '../../../services/api/reallis'
    import {userIsAdmin} from 'src/components/main/#services/userRole'
    import {getStakingBalance} from 'src/components/cabinet/#services/staking'

    export let template

    let notificationsCount = 4
    let mobileMenuOpened = false
    let url = window.location.pathname

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    let dashboardLink = ''
    $: if ($userIsAdmin.value && process.env.DASHBOARD_URL) {
        dashboardLink = process.env.DASHBOARD_URL
    }

    function logOut() {
        api.ws.ws1.auth.logout()
    }
</script>

<div class="menu-template-{template}">
    <button class="hamburger-btn" class:active={mobileMenuOpened} on:click={() => { mobileMenuOpened = true }}>
        <IconifyIcon icon={userIcon} class="hamburger-icon"/>
        <!--<div class="notifications-count" class:active={notificationsCount > 0}>{notificationsCount}</div>-->
    </button>
    <div class="hamburger-background" class:active={mobileMenuOpened} on:click={() => { mobileMenuOpened = false }}></div>
    <div class="hamburger-menu" class:active={mobileMenuOpened} on:click={() => { mobileMenuOpened = false }}>
        <Link to="activity" class="balance">
            <img src="{balanceIcon}" class="balance-icon" alt="">
            <span class="notranslate">{!$myBalance.hasValue ? ".." : ((Math.floor($myBalance.value.data.totalBalance)*10000)/10000)} LIS</span>
        </Link>
        <button class="hamburger-btn" on:click={() => { mobileMenuOpened = false }}>
            <span></span>
            <span></span>
            <span></span>
        </button>
        <div class="hamburger-menu-overflow">
            <ul class="user-menu">
                {#if dashboardLink}
                <li class="user-menu-item">
                    <a href="{dashboardLink}" class="user-menu-link" target="_blank" style="color: #FF5D1C">
                        <IconifyIcon icon={dashboardIcon} class="user-menu-icon"/>
                        <span>Dashboard</span>
                    </a>
                </li>
                {/if}
                <li class="user-menu-item">
                    <Link to="marketplace" class="user-menu-link" style="color: #FF5D1C">
                        <IconifyIcon icon={marketplaceIcon} class="user-menu-icon"/>
                        <span>Marketplace</span>
                    </Link>
                </li>
                <li class="user-menu-item {url === '/account' ? 'menuitem-active' : ''}">
                    <Link to="account" class="user-menu-link">
                        <IconifyIcon icon={userIcon} class="user-menu-icon"/>
                        <span>Account</span>
                    </Link>
                </li>
                <li class="user-menu-item {url === '/inventory' ? 'menuitem-active' : ''}">
                    <Link to="inventory" class="user-menu-link">
                        <IconifyIcon icon={inventoryIcon} class="user-menu-icon"/>
                        <span>Inventory</span>
                    </Link>
                </li>
                <!--
                <li class="user-menu-item {url === '/spin' ? 'menuitem-active' : ''}">
                    <Link to="spin" class="user-menu-link">
                        <IconifyIcon icon={spinIcon} class="user-menu-icon"/>
                        <span>Spin</span>
                    </Link>
                </li>
                -->
                {#if $getStakingBalance.hasValue && $getStakingBalance.value?.isUserParticipate}
<!--                <li class="user-menu-item {url === '/staking' ? 'menuitem-active' : ''}">-->
<!--                    <Link to="staking" class="user-menu-link">-->
<!--                        <IconifyIcon icon={stakingIcon} class="user-menu-icon"/>-->
<!--                        <span>Staking</span>-->
<!--                    </Link>-->
<!--                </li>-->
                {/if}
                <li class="user-menu-item {url === '/swap' ? 'menuitem-active' : ''}">
                    <Link to="swap" class="user-menu-link">
                        <IconifyIcon icon={swapIcon} class="user-menu-icon"/>
                        <span>Swap</span>
                    </Link>
                </li>
                <li class="user-menu-item {url === '/memberships' ? 'menuitem-active' : ''}">
                    <Link to="memberships" class="user-menu-link">
                        <IconifyIcon icon={membershipsIcon} class="user-menu-icon"/>
                        <span>Memberships</span>
                    </Link>
                </li>
                <li class="user-menu-item {url === '/referrals' ? 'menuitem-active' : ''}">
                    <Link to="referrals" class="user-menu-link">
                        <IconifyIcon icon={referralsIcon} class="user-menu-icon"/>
                        <span>Referrals</span>
                    </Link>
                </li>
                <li class="user-menu-item {url === '/activity' ? 'menuitem-active' : ''}">
                    <Link to="activity" class="user-menu-link">
                        <IconifyIcon icon={runIcon} class="user-menu-icon"/>
                        <span>Activity</span>
                    </Link>
                </li>
                <!--
                <li class="user-menu-item {url === '/activity' ? 'menuitem-active' : ''}">
                    <Link to="notifications" class="user-menu-link">
                        <IconifyIcon icon={notificationIcon} class="user-menu-icon"/>
                        <span>Notifications</span>
                        <span class="notifications-count">{notificationsCount}</span>
                    </Link>
                </li>
                -->
                <li class="user-menu-item {url === '/settings' ? 'menuitem-active' : ''}">
                    <Link to="/settings" class="user-menu-link">
                        <IconifyIcon icon={cogIcon} class="user-menu-icon"/>
                        <span>Settings</span>
                    </Link>
                </li>
                <li class="user-menu-item help-center-item">
                    <Link to="support" class="user-menu-link">
                        <IconifyIcon icon={questionIcon} class="user-menu-icon"/>
                        <span>Help Center</span>
                    </Link>
                </li>
                <li class="user-menu-item logout-item">
                    <div on:click={logOut} class="user-menu-link">
                        <IconifyIcon icon={logoutIcon} class="user-menu-icon"/>
                        <span>Log out</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
<style>
    .header :global(.menu-icon) {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #454d66;
        border-radius: 6px;
        margin-right: 10px;
    }

    .app :global(.menu-template-main) {
        position: fixed;
        right: 20px;
        top: 7px;
    }

    .header :global(.menu-icon.active) {
        border-color: #FF5D1C;
    }

    .hamburger-btn :global(.hamburger-icon) {
        color: #d3d9e1;
        font-size: 24px;
        margin: 12px 6px;
    }

    .header .menu {
        margin-left: 174px;
        display: flex;
        align-items: center;
    }

    .header :global(.menu-item) {
        font-family: 'Inter', sans-serif;
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
        color: white;
        text-decoration: none;
        display: flex;
        align-items: center;
        transition: .25s;
    }

    .header :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .header :global(.menu-item:not(:last-child)) {
        margin-right: 51px;
    }

    .header :global(.btn-secondary) {
        margin-right: 8px;
    }

    .notification-icon {
        color: white;
        border: 1px solid #3A3F5D;
        box-sizing: border-box;
        border-radius: 6px;
        width: 40px;
        height: 40px;
        margin: 8px 50px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
    }

    .notifications-count {
        height: 20px;
        min-width: 20px;
        background: #FF5D1C;
        color: white;
        border-radius: 10px;
        left: 100%;
        top: -10px;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        padding: 0 6px;
        position: absolute;
        text-align: center;
        transform: translateX(-50%);
    }

    .hamburger-menu :global(.balance) {
        background: #3b4358;
        font-size: 14px;
        color: #CAD5E0;
        display: flex;
        align-items: center;
        padding: 10px;
        margin-right: 50px;
        border-radius: 6px;
        line-height: normal;
        text-decoration: none;
    }

    .balance-icon {
        height: 30px;
        width: 29px;
        margin-right: 10px;
        filter: grayscale(1) brightness(1.1);
        transition: .25s;
    }

    .app :global(.balance:hover img) {
        filter: none;
    }

    .app :global(.user) {
        display: flex;
        align-items: center;
        text-decoration: none;
    }

    .hamburger-menu :global(.avatar) {
        background: #3b4358;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
        font-size: 18px;
        font-weight: 500;
        text-transform: uppercase;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hamburger-menu :global(.nickname) {
        line-height: 20px;
    }

    .hamburger-menu :global(.user-nickname) {
        font-size: 15px;
        font-weight: 500;
        color: white;
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .hamburger-menu :global(.user-id) {
        font-size: 15px;
        color: #A0AEC0;
    }

    .hamburger-btn {
        display: none;
    }

    .hamburger-btn span {
        background: white;
        margin: 10px 0;
        border-radius: 2px;
        display: block;
        height: 2px;
        transition: .25s;
    }

    .hamburger-btn span:nth-child(1) {
        width: 22px;
        margin-left: 10px;
    }

    .hamburger-btn span:nth-child(2) {
        width: 32px;
    }

    .hamburger-btn span:nth-child(3) {
        width: 17px;
        margin-left: 15px;
    }

    .hamburger-menu .hamburger-btn span:nth-child(1) {
        width: 36px;
        transform: rotate(-45deg) translate(-6px, 12px);
    }

    .hamburger-menu .hamburger-btn span:nth-child(2) {
        opacity: 0;
    }

    .hamburger-menu .hamburger-btn span:nth-child(3) {
        width: 36px;
        transform: rotate(45deg) translate(-8px, -8px);
    }

    .hamburger-menu {
        position: fixed;
        width: 270px;
        height: 100%;
        top: 0;
        right: -100%;
        background: #26244D;
        transition: .5s;
        z-index: 11;
    }

    .hamburger-menu.active {
        right: 0;
    }

    .hamburger-background {
        width: 100%;
        height: 100%;
        position: fixed;
        visibility: hidden;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
        opacity: 0;
        transition: .6s;
        z-index: 11;
    }

    .hamburger-background.active {
        visibility: visible;
        opacity: 1;
    }

    .user-menu {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .user-menu-item :global(.user-menu-link) {
        display: block;
        padding: 10px 5px;
        font-size: 16px;
        color: white;
        margin: 5px 10px;
        position: relative;
        border-radius: 6px;
        text-decoration: none;
        transition: all .4s;
        list-style: none;
    }

    .user-menu-item :global(.user-menu-icon) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: top;
        width: 20px;
    }

    .help-center-item {
        border-top: 2px solid #57548A;
        margin-top: 8px;
        padding: 15px 0 5px;
    }

    .logout-item .user-menu-link {
        color: #EB5757;
        margin-bottom: 30px;
    }

    .hamburger-menu-overflow {
        overflow: auto;
        height: calc(100vh - 60px);
        margin-top: 12px;
    }

    @media(max-width: 992px) {
        .hamburger-btn {
            display: block;
            background: none;
            border: 0;
            padding: 0 7px;
            position: fixed;
            right: 20px;
            top: 30px;
            z-index: 11;
        }

        .hamburger-menu .hamburger-btn {
            position: absolute;
            right: 17px;
            top: 6px;
            padding: 0;
        }

        .menu-template-cabinet :global(.hamburger-btn) {
            top: 6px;
        }

        .menu {
            display: none;
        }

        .balance,
        .user {
            display: none;
        }

        .hamburger-menu :global(.balance) {
            display: inline-block;
            margin: 10px 0 0 15px;
            padding: 8px 10px;
        }

        .hamburger-menu :global(.user) {
            display: flex;
            margin: 10px 15px;
            padding: 15px 0;
            border-top: 1px solid #454d66;
            border-bottom: 1px solid #454d66;
            text-decoration: none;
        }

        .balance-icon {
            height: 24px;
            width: 24px;
        }

        .hamburger-menu :global(.balance span) {
            vertical-align: middle;
        }

        .hamburger-menu :global(.avatar) {
            width: 40px;
            height: 40px;
        }

        .hamburger-menu :global(.user-nickname) {
            font-size: 14px;
            max-width: 190px;
        }

        .hamburger-menu :global(.user-id) {
            font-size: 12px;
            margin-bottom: -2px;
        }

        .hamburger-menu .menu {
            display: block;
            margin: 25px 15px;
            border-bottom: 1px solid #454d66;
        }

        .hamburger-menu .menu-icon {
            border: 0;
            width: 24px;
            height: 24px;
            filter: brightness(10);
        }

        .hamburger-menu .menu-icon.active {
            filter: none;
        }

        .hamburger-menu .menu-icon.active + span {
            color: #FF5D1C;
        }

        .hamburger-menu :global(.menu-item) {
            font-size: 16px;
            margin: 25px 0;
            width: 100%;
        }

        .hamburger-btn .notifications-count {
            top: 0;
            left: auto;
            right: -5px;
            transform: none;
        }

        .hamburger-menu .notifications-count {
            top: 50%;
            left: auto;
            right: 5px;
            margin-top: -10px;
            transform: none;
        }

        :global(.menu-template-main .hamburger-btn) {
            display: none !important;
        }

        :global(.app.home-page .hamburger-btn) {
            top: 12px;
        }
    }

    @media(max-width: 991px) {
        :global(.menu-template-main .hamburger-btn) {
            display: block !important;
        }

        .balance-icon {
            margin-right: 5px;
        }
    }

    @media(max-width: 767px) {
        .hamburger-btn {
            right: 0;
            top: 7px;
        }
    }
</style>
